import { Link } from 'react-router-dom';
import './AddNewFarmCard.scss';
import { Card } from 'app/agriculture/components/Card/Card';
import { PlusIcon } from 'app/agriculture/icons';
import classNames from 'classnames';

interface AddNewFarmCardProps {
    className: string;
}

export function AddNewFarmCard({ className }: AddNewFarmCardProps) {
    return (
        <Card className={classNames('AddNewFarmCard', className)}>
            <Link className="AddNewFarmCard__interactable" to="/create-farm">
                <div className="AddNewFarmCard__image">
                    <PlusIcon size={48} />
                </div>
                <div className="AddNewFarmCard__content">
                    <div className="AddNewFarmCard__name">Add New Farm</div>
                    <div className="AddNewFarmCard__icon">
                        <PlusIcon />
                    </div>
                </div>
            </Link>
        </Card>
    );
}
